import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import Dashboard from './components/dashboard'; 
import { Layout } from './components/Layout';
import LoginPage from './components/LoginPage';
import { ResetPassword } from './components/resetPassword';
import { ForgotPassword } from './components/ForgotPassword';
import { Gateway, AppInsightsInstrumentationKey } from './BaseUrl';
import { getAppInsights } from './AppInsights/TelemetryService';
import TelemetryProvider from './AppInsights/TelemetryProvider';

let appInsights = null;
class App extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            token: sessionStorage.getItem('tkn'),
            values: '',
            logo: "default",
            isHomePage: false,
            isExpired: false
        }

        this.Logout = this.Logout.bind(this);
    }

    setLogo = (logoName, isHome = false) => {
        var logoClass = "";
        switch (logoName) {
            case "user":
                logoClass = "far fa-user"
                break;

            case "statement":
                logoClass = "fas fa-receipt"
                break;

            case "card":
                logoClass = "far fa-credit-card"
                break;

            case "default":
            default:
                logoClass = "default"
                break;
        }
        this.setState({
            logo: logoClass,
            isHomePage: isHome
        });
    }

    Logout(isExpired = false) {
        sessionStorage.removeItem('tkn');
        
        this.setState({            
            token: null,
            values: '',
            isExpired: isExpired
        });
    }    

    render() {
        //use this to disable console.log for live servicing site
        //console.log = function () { }
        return (
            <TelemetryProvider instrumentationKey={AppInsightsInstrumentationKey} after={() => { appInsights = getAppInsights() }}>
                <div className="App">
                    <Layout logo={this.state.logo} isHomePage={this.state.isHomePage} history={this.props.history} LoggedIn={this.state.token != null} Logout={(e) => this.Logout(e)}>
                            {
                                (this.state.token == null) ?
                                    <Switch>
                                        <Route exact path='/' component={(props) => (<LoginPage isExpired={this.state.isExpired} {...this.props} setToken={(tkn) => this.setState({ token: tkn, isExpired: false })} />)} />
                                        <Route exact path='/login' component={(props) => (<LoginPage isExpired={this.state.isExpired} {...this.props} setToken={(tkn) => this.setState({ token: tkn, isExpired: false })} />)} />                                                    
                                        <Route exact path='//login' component={(props) => (<LoginPage isExpired={this.state.isExpired} {...this.props} setToken={(tkn) => this.setState({ token: tkn, isExpired: false  })} />)} />                                                    
                                        <Route path='/sign-up' component={(props) => <ResetPassword isSignUp={true} {...this.props} />} />
                                        <Route path='//sign-up' component={(props) => <ResetPassword isSignUp={true} {...this.props} />} />
                                        <Route path='/reset-password' component={(props) => <ResetPassword {...this.props} />} />
                                        <Route path='//reset-password' component={(props) => <ResetPassword {...this.props} />} />
                                        <Route path='/forgot-password' component={(props) => <ForgotPassword {...this.props} />} />
                                        <Route path='//forgot-password' component={(props) => <ForgotPassword {...this.props} />} />
                                        <Route component={() => <LoginPage {...this.props} isExpired={this.state.isExpired} setToken={(tkn) => this.setState({ token: tkn, isExpired: false  })} />} />
                                    </Switch>
                                :
                                <Dashboard {...this.props} token={this.state.token} Logout={(e) => this.Logout(e)} changeLogo={(e, a = false) => this.setLogo(e, a)} />
                            }                                     
                    </Layout>
                </div>
            </TelemetryProvider>              
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js